// @flow
import React, { Component } from "react";
import FormField from "./FormField";
import { Button } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import classNames from "classnames";

const defaultValidator = isRequired => {
  return (value) => !(isRequired && value.trim() === "");
}

const defaultState = {
  isRequested: false,
  fields: {
    reCaptcha: {
      value: "",
      validateState: null,
      message: ""
    }
  },
};

export default class ContactUsFrom extends Component {
  constructor(props) {
    super(props);
    this.state = defaultState;
    this.onSubmit = this.handleOnSubmit.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.handleStateReCaptcha = this.handleStateReCaptcha.bind(this);
    this.fields = [
      {
        placeholder: "Full Name",
        name: "name",
        isRequired: true,
        type: "text",
        autoComplete: "off"
      },
      {
        placeholder: "Email",
        name: "email",
        isRequired: true,
        validator: this.emailValidator.bind(this),
        errorMessage: "Invalid Email Input",
        type: "text",
        autoComplete: "off"
      },
      {
        placeholder: "Company",
        name: "company",
        isRequired: true,
        type: "text",
        autoComplete: "off"
      },
      {
        placeholder: "Phone Number",
        name: "phone",
        isRequired: false,
        type: "text",
        autoComplete: "off"
      },
      {
        placeholder: "Comment",
        name: "comment",
        isRequired: false,
        componentClass: "textarea",
        rows: 4,
      },

    ];

  }

  emailValidator(value) {
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value);

  }

  getAllData() {
    const data = {};
    for (const key in this.state.fields) {
      const field = this.state.fields[ key ];
      data[ key ] = field && field.value;
    }

    return data;
  }

  handleOnSubmit(e) {
    e.preventDefault();
    this.setState({ isRequested: true });
    this.reCaptcha.execute()
    if (this.validateAll() && this.reCaptcha.getValue()) {
      this.sendRequest()
    } else {
      this.setState({ isRequested: false });
    }
    return false;
  }

  handleState(validator, errorMessage, e) {
    const state = { ...this.state.fields };
    const value = e.target.value || "";
    const field = this.fields.find((item) => item.name === e.target.id);

    const [ validateState, message ] = this.validate(value, validator || defaultValidator(field.isRequired), field.isRequired, errorMessage);

    state[ e.target.id ] = { value, validateState, message: message };
    this.setState({ fields: state });
    e.preventDefault();
  }

  validateAll() {
    let error = this.state.error;
    this.fields.forEach(field => {
      const state = this.state.fields;

      const { value = "" } = state[ field.name ] || {};

      const [ validateState, message ] = this.validate(value, field.validator || defaultValidator(field.isRequired), field.isRequired, field.errorMessage);

      if (validateState === "error") {
        error = true;
        state[ field.name ] = { value, validateState, message: message };
        this.setState({ fields: state });
      }
    });


    return !error;
  }

  validate(value, validator, isRequired = false, message = "Invalid Input", requiredMessage = "can not be blank") {
    if (value === "" && !isRequired) {
      return [];
    }

    if (value === "" && isRequired) {
      return [ "error", requiredMessage ]
    }

    if (validator(value.trim())) {
      return [ "success", null ];
    } else {
      return [ "error", message ]
    }

  }

  checkOnSelect(field) {
    const state = this.state.fields[ field ] || {};
    const { value } = state;
    return value && "on-select";
  }

  sendRequest() {
    // request to api
    fetch("/contactUs", {
      method: "POST", body: JSON.stringify(this.getAllData()), headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then((data) => {
        console.log(data)
      }).catch(() => {
      this.setState({ isRequested: false });
    });
  }

  handleStateReCaptcha(value) {
    const state = { ...this.state.fields };
    const [ validateState, message ] = this.validate(value, defaultValidator(true), true, null, "Please processed reCaptcha");
    state[ "reCaptcha" ] = { value, validateState, message: message, response: this.reCaptcha.get };

    this.setState({ fields: state });

    if (this.validateAll() && validateState !== "error") {
      this.setState({ isRequested: true });
      // request to api
      this.sendRequest()
    } else {
      this.setState({ isRequested: false });
    }
  }

  renderFormGroup(item, id) {
    let
      {
        name,
        placeholder,
        isRequired = false,
        validator,
        errorMessage,
        ...props
      } = item;

    const stateName = this.state.fields[ name ] || {};

    if (isRequired) {
      placeholder += "*";
    }
    return (
      <FormField
        key={id}
        controlId={name}
        placeholder={placeholder}
        onChange={this.handleState.bind(this, validator, errorMessage)}
        validationState={ stateName.validateState }
        help={stateName.message}
        className={this.checkOnSelect(name)}
        inputRef={ref => {
          this[ name ] = ref
        }}
        {...props}
      />
    );
  }

  render() {
    const formFields = this.fields.map(this.renderFormGroup);
    const reCaptcha = this.state.fields.reCaptcha;
    const reCaptchaClassName = classNames("form-group has-feedback reCaptcha", reCaptcha.validateState === "error" && "has-error");

    if (this.state.isRequested) {
      return (<div>Thank You</div>);
    }
    return (
      <form className="contact-us-form" onSubmit={this.onSubmit}>
        {formFields}
        <Button type="submit" className="btn-lg btn-primary" disabled={this.state.isRequested}>SUBMIT</Button>
        <div className={reCaptchaClassName}>
          <ReCAPTCHA
            ref={ref => {
              this.reCaptcha = ref
            }}
            sitekey="6LebExwUAAAAABmaXfJh_VrWWhnlwgcOiqbMtbam"
            size="invisible"
            onChange={this.handleStateReCaptcha.bind(this)}
          />
          {reCaptcha.message && <div className="help-block">{reCaptcha.message}</div>}
        </div>
      </form>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Froms/ContactUsFrom.js